
import React from 'react';
import { Poll } from '@/types/poll';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import PollDisplay from '@/components/polls/shared/PollDisplay';

interface ClosedPollsGridProps {
  polls: Poll[];
  userVotes?: Record<string, number>;
}

const ClosedPollsGrid = ({ polls, userVotes = {} }: ClosedPollsGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {polls.map(poll => {
        const hasVoted = userVotes[poll.id] !== undefined;
        
        // Add the user's vote to the poll results object if they've voted
        const displayPoll = { ...poll };
        
        if (hasVoted) {
          const userVoteOptionId = userVotes[poll.id];
          displayPoll.results = {
            ...(displayPoll.results || { totalVotes: displayPoll.total_votes, topOption: '' }),
            selectedOptionId: userVoteOptionId
          };
        }
        
        return (
          <Card key={poll.id} className="overflow-hidden">
            <CardHeader className="pb-2">
              <CardTitle className="text-base">{poll.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <PollDisplay
                poll={displayPoll}
                hasVoted={hasVoted}
                onVote={() => {}} // Closed polls can't be voted on
                canVote={false}
                variant="compact"
                showShareButtons={false}
                showLocation={true}
              />
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default ClosedPollsGrid;
